import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private toastr: ToastrService,private route: Router
  ) { 
    const tokenExpiryTime = localStorage.getItem('tokenExpiryTime');
    
    if (tokenExpiryTime) {
      const currentTime = new Date().getTime();
      
      if (currentTime > Number(tokenExpiryTime)) {
        // Token expired, remove it
        this.toastr.error('Session expired. Please login again.', 'Error',)
        // auto logout if 401 response returned from apis
        sessionStorage.clear();
        localStorage.clear();
        this.route.navigate(['/account/login']);
      }
    }
  }
  ngOnInit() {
    //  document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");  
  }

}
